module.exports = "/_next/static/images/info_active-8fc4e08338f07a90d8a617e43eae7216.svg";